export const COMPANY_ADDRESS = "375 Airline Society, Lahore, Pakistan";
export const COMPANY_ADDRESS_MAP_QUERY =
  "375+Airline+Society,+Lahore,+Pakistan";
